export default __webpack_public_path__ + "static/media/banner_1.0f82fc5f.jpg";